import React from "react";
import Banner1 from "../../assets/images/courasel-1.png"

export const Banner = () => {
    return (
          <div className="w-full pt-14 md:pt-28">
            <div 
                className="grid place-items-center justify-start md:min-h-[34.5rem] text-left px-4 sm:px-8 md:px-12 lg:px-16 xl:px-20 py-8 md:py-0" 
                style={{ backgroundImage: `url(${Banner1})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}
            >
                <div className="max-w-64 md:max-w-2xl lg:max-w-3xl">
                    <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold pb-2 md:pb-4 leading-tight">
                        Menyediakan bibit parfum original
                    </h1>
                    <p className="text-sm sm:text-base md:text-lg text-gray-500 leading-relaxed">
                        Kami menyediakan berbagai macam bibit import seperti Dullburg, Iberchem dan IFF, dan yang pasti original.
                    </p>
                </div>
            </div>
        </div>
    )
}